export const SEARCH_BY_STRING = "1";
export const SEARCH_BY_SUBSTRING = "2";

export const SEARCH_BY_DATE = "date";
export const SEARCH_BY_DATE_BEFORE = "before";
export const SEARCH_BY_DATE_AFTER = "after";
export const SEARCH_BY_PERIOD = "range";

export const SEARCH_BY_LIST = "1";
export const SEARCH_BY_LIST_EXCLUDE = "2";

export const SEARCH_BY_NUMBER_LESS = "1";
export const SEARCH_BY_NUMBER_MORE = "2";
export const SEARCH_BY_NUMBER = "3";
export const SEARCH_BY_RANGE = "4";